
import { Route } from 'react-router-dom';
import LandingWrapper from '../pages/LandingWrapper';
import ReferralLanding from '../pages/ReferralLanding';
import Contact from '../pages/Contact';
import Support from '../pages/Support';
import Legal from '../pages/Legal';
import About from '../pages/About';
import Blog from '../pages/Blog';
import BlogPost from '../pages/BlogPost';
import ConfirmationPage from '../pages/ConfirmationPage';
import SharedGamePlan from '../pages/SharedGamePlan';
import SharedTechnique from '../pages/SharedTechnique';

export const LandingRoutes = [
  <Route key="landing" path="/landing" element={<LandingWrapper />} />,
  <Route key="referral" path="/ref/:referralCode" element={<ReferralLanding />} />,
  <Route key="contact" path="/contact" element={<Contact />} />,
  <Route key="support" path="/support" element={<Support />} />,
  <Route key="legal" path="/legal" element={<Legal />} />,
  <Route key="about" path="/about" element={<About />} />,
  <Route key="blog-index" path="/blog" element={<Blog />} />,
  <Route key="blog-post" path="/blog/:slug" element={<BlogPost />} />,
  <Route key="confirmation" path="/confirmation" element={<ConfirmationPage />} />,
  <Route key="shared-game-plan" path="/shared/game-plan/:shareId" element={<SharedGamePlan />} />,
  <Route key="shared-technique" path="/shared/technique/:shareId" element={<SharedTechnique />} />
];
